import styles from './style.module.css';

export const Thuthuat1 = () => {
  return (
    <div className={styles.thuthuatContainer}>
      <p className={styles.thuthuatTitle}>
        <b>THỦ THUẬT LV1 </b> PHƯƠNG PHÁP TỰ CHƠI BACARAT
      </p>
      <img style={{ width: '70%' }} src="/assets/thuthuat/tt1.jpg" alt="thuthuat1" />
      <p><b>-HỆ SỐ CÔNG THỨC SỐ 1</b> : MẸO CẦU BỆT : KHI KẾT QUẢ CHIA BÀI  XUẤT HIỆN RA 1 NHÀ THẮNG LIÊN TỤC TRONG NHIỀU VÁN CƯỢC ĐỘ DÀI NHIỀU CÁC CẦU BỆT THƯỜNG KÉO  DÀI KHOẢNG 90 - 15 TAY . CÓ CẦU BỆT TẬN 17 TAY CÁCH CHƠI HIỆU QUẢ CẦU BỆT LÀ NẾU  CÓ 3 VÁN LIÊN TỤC VÈ CÙNG BÊN 1 CỬA ĐÊN TAY THỨ 4 THÌ CÓ THỂ THAM GIA . CẦU BỆT CÀNG DÀI SỐ TIỀN NGƯỜI CHƠI CÓ  THỂ  GOM ĐƯỢC CÀNG LỚN </p>
      <p><b>-HỆ SỐ CÔNG THỨC SỐ 2</b> : KẾT QUẢ TRẢ TRẢ LẠI XUẤT HIỆN GIỐNG NHAU THEO TẦN SỐ2 CỬA PLAYRE VÀ BANKER LÀ 22 HOẶC 33 KHÍ GẶP VÁN BÀI CÓ SỰ TRÙNG HỢP NÀY BẠN CẦN QUAN SÁT BẢNG TỔNG KẾT LỚN ĐỂ QUYẾT ĐỊNH</p>
      <p><b>-HỆ SỐ CÔNG THỨC SỐ 3</b> : PHƯƠNG PHÁP BACARAT  CẦU CHẠY ĐUÔI LÀ MỘT CHIẾN THUẬT CHƠI BACCARAT ONLINE DỰA TRÊN VIỆC ĐẦU TƯ THEO KẾT QUẢ GIỐNG  VỚI VÁN TRƯỚC ĐÓ . VÍ DỤ NẾU VÁN CHƠI TRƯỚC ĐÓ LÀ NHÀ BANKER THẮNG . BẠN SẼ ĐẦU TƯ VÀO NHÀ BANKER TRONG VÁN CHƠI TIẾP  THEO . NẾU VÁN CHƠI TRƯỚC ĐÓ LÀ HOÀ . BẠN SẼ ĐẦU TƯ CHO HOÀ TRONG VÁN CHƠI TIẾP THEO . MỤC TIÊU CỦA PHƯƠNG PHÁP NÀY LÀ BẮT ĐƯỢC NHỮNG CẦU ĐỀU CHÂN HOẶC CẦU ĐƠN</p>
    </div>
  )
}

export const Thuthuat2 = () => {
  return (
    <div className={styles.thuthuatContainer}>
      <p className={styles.thuthuatTitle}>
        <b>THỦ THUẬT LV2 </b> PHƯƠNG PHÁP TỰ CHƠI BACARAT
      </p>
      <img style={{ width: '70%' }} src="/assets/thuthuat/tt2.jpg" alt="thuthuat1" />
      <p><b>- CÁCH BẮT CẦU 2-1-2</b></p>
      <p>ĐANG THẾ CẦU CHƯA CHẠM CHÂN 4 NÊN ĐỂ Ý SẼ VỀ 2-1-2 VÀ THẾ CẦU 22 ANH EM CỨ THEO BÁM BỆT               THẾ CẦU TAM GIÁC ĐI XÚN KHI ĐANG NHƯ VẬY KHẢ NĂNG VỀ CẦU 1-1 KHÁ CAO
        VÀ THƯỜNG SẼ CÓ BỆT 1-1 TRƯỜNG HỢP 2 LÀ SẼ CÓ 4-3-2 NHƯ HÌNH BẢNG</p>
      <p><b>- CÁCH BẮT CẦU 3-2-3</b></p>
      <p>NHỮNG BÀN NÀY THÌ THƯỜNG THẾ CẦU MÌNH CHỈ NÓ SẼ VỀ 3-2-3 XONG RỒI VỀ 2-2 <br />
        CHÚ Ý THEO LỆNH NHƯ NÀY CÓ THỂ GẤP LÊN VÀ SAU 3-2-3 LÀ CÓ THỂ MÌNH NGƯNG SANG BÀN MỚI</p>
      <p><b>- CÁCH BẮT CẦU 1-1 BỆT CHÂN</b></p>
      <p>CẦU NÀY TỶ LỆ ĐANG VỀ 1-1 TAY THỨ 4 THEO ĐẾN CHẠM 2 LẦN SẼ CHUYỂN ĐỔI QUA HƯỚNG KHÁC
        NHỮNG THẾ CẦU NHƯ NÀY SẼ ĐI 1 LẦN NỮA BẮT ĐƯỢC ĂN VÀI TAY MÌNH LẠI ĐỔI BÀN MỚI
        ĐỂ Ý CẦU 2-1-2 THEO DÕI 2 3 TAY SAU CÓ THỂ VỀ 123 NÊN ANH EM CHƠI CÓ LÃI CÓ THỂ NGƯNG.</p>
    </div>
  )
}

export const Thuthuat3 = () => {
  return (
    <div className={styles.thuthuatContainer}>
      <p className={styles.thuthuatTitle}>
        <b>THỦ THUẬT LV3 </b> PHƯƠNG PHÁP TỰ CHƠI BACARAT
      </p>
      <img style={{ width: '70%' }} src="/assets/thuthuat/tt3.jpg" alt="thuthuat1" />
      <p style={{ textAlign: 'center' }}><b>PHƯƠNG PHÁP CHƠI BACCARAT LUÔN THẮNG VÀ CHỈ THUA KHI GẶP CẦU 1-1 6 TAY TRỞ LÊN.</b></p>
      <img style={{ width: '70%' }} src="/assets/thuthuat/tt3.1.jpg" alt="thuthuat1" />
      <p style={{ textAlign: 'center' }}><b>PHƯƠNG PHÁP CHƠI BACCARAT CHỈ THUA KHI GẶP CẦU 2-2 6 TAY TRỞ LÊN.</b></p>
    </div>
  )
}


export const Thuthuat4 = () => {
  return (
    <div className={styles.thuthuatContainer}>
      <p className={styles.thuthuatTitle}>
        <b>THỦ THUẬT LV4 </b> PHƯƠNG PHÁP TỰ CHƠI BACARAT
      </p>
      <p>
        �� 5️⃣ AI NÊN DÙNG CHIẾN LƯỢC 1-3-2-6?<br />
        ✅ Người muốn nhân lợi nhuận nhanh nhưng không chịu rủi ro cao<br />
        ✅ Người có kỷ luật, không phá vỡ chiến lược khi thắng/thua<br />
        ✅ Người chơi theo cầu bệt, cầu 1-1, không đánh ngẫu nhiên<br />
        <br />
        �� Bạn muốn học cách áp dụng 1-3-2-6 chi tiết hơn? �� Inbox ngay để nhận hướng dẫn VIP!<br />
        <br />
        �� 1️⃣ CHIẾN LƯỢC ĐI VỐN 50/50 LÀ GÌ?<br />
        �� Chiến lược 50/50 = Chia vốn thành 50 đơn vị nhỏ & chỉ cược 2% mỗi ván<br />
        �� Mục tiêu: Kiểm soát tài khoản, hạn chế rủi ro và tối đa hóa lợi nhuận dài hạn<br />
        <br />
        �� �� Nguyên tắc quan trọng:<br />
        ✅ Không cược tất tay – Chỉ cược 2% tài khoản mỗi ván<br />
        ✅ Thắng → Giữ nguyên mức cược<br />
        ✅ Thua → Giảm 50% mức cược để bảo toàn vốn<br />
        <br />
        �� �� Kết luận: 50/50 giúp bạn duy trì cuộc chơi lâu dài, tránh all-in và bảo vệ tài khoản khỏi cháy!<br />
        <br />
        �� 2️⃣ CÁCH ÁP DỤNG CHIẾN LƯỢC 50/50<br />
        �� Nguyên tắc:<br />
        �� Giả sử bạn có 10 triệu → Chia thành 50 đơn vị = 200k/đơn vị<br />
        �� Ván đầu tiên → Cược 2% tài khoản (200k)<br />
        �� Nếu thắng → Giữ nguyên mức cược 200k<br />
        �� Nếu thua → Giảm 50% xuống còn 100k, không gấp thếp<br />
        <br />
        �� Ví dụ chi tiết:<br />
        <br />
        Ván cược<br />
        <br />
        Mức cược (VNĐ)<br />
        <br />
        Kết quả<br />
        <br />
        Tổng lãi/lỗ<br />
        <br />
        1️⃣<br />
        <br />
        200k<br />
        <br />
        ❌ Thua<br />
        <br />
        -200k<br />
        <br />
        2️⃣<br />
        <br />
        100k<br />
        <br />
        ❌ Thua<br />
        <br />
        -300k<br />
        <br />
        3️⃣<br />
        <br />
        100k<br />
        <br />
        ✅ Thắng<br />
        <br />
        -200k<br />
        <br />
        4️⃣<br />
        <br />
        200k<br />
        <br />
        ✅ Thắng<br />
        <br />
        0<br />
        <br />
        5️⃣<br />
        <br />
        200k<br />
        <br />
        ✅ Thắng<br />
        <br />
        +200k<br />
        �� �� Kết luận: Dù thua 2 ván đầu, bạn vẫn có lãi nhờ kiểm soát vốn chặt chẽ!<br />
        <br />
        �� 3️⃣ ƯU ĐIỂM & NHƯỢC ĐIỂM CỦA CHIẾN LƯỢC 50/50<br />
        ✅ ƯU ĐIỂM:<br />
        ✔️ Bảo vệ tài khoản, không cháy nhanh như Martingale<br />
        ✔️ Duy trì lợi nhuận ổn định, không cần chuỗi thắng dài<br />
        ✔️ Không cần vốn quá lớn, phù hợp với mọi người chơi<br />
        <br />
        ❌ NHƯỢC ĐIỂM:<br />
        ⚠️ Lợi nhuận tăng chậm hơn so với Martingale hoặc Paroli<br />
        ⚠️ Cần kiên nhẫn & kỷ luật cao<br />
        <br />
        �� �� KẾT LUẬN: Chiến lược 50/50 là phương pháp đi vốn an toàn, giúp người chơi duy trì cuộc chơi dài hạn!<br />
        <br />
        �� 4️⃣ MẸO ÁP DỤNG 50/50 HIỆU QUẢ NHẤT<br />
        �� 1️⃣ Chỉ cược 2% tài khoản mỗi ván – Không all-in!<br />
        �� Duy trì vốn lâu dài, không bị cháy vì vài ván thua liên tiếp!<br />
        <br />
        �� 2️⃣ Không tăng cược khi thua – Giảm 50% để bảo toàn vốn!<br />
        �� Không gỡ gạc, chỉ tập trung vào quản lý rủi ro!<br />
        <br />
        �� 3️⃣ Chơi theo cầu đẹp – Không đánh ngẫu nhiên!<br />
        �� Dùng TOOL nhận diện cầu để chọn thời điểm vào lệnh!<br />
        <br />
        �� �� KẾT LUẬN: 50/50 chỉ thực sự hiệu quả khi đi kèm với phân tích cầu chính xác & kỷ luật chặt chẽ!<br />
        <br />
        �� 5️⃣ AI NÊN DÙNG CHIẾN LƯỢC 50/50?<br />
        ✅ Người muốn chơi dài hạn mà không bị cháy tài khoản<br />
        ✅ Người không thích rủi ro cao nhưng vẫn muốn lợi nhuận ổn định<br />
        ✅ Người có kỷ luật, không phá vỡ chiến lược khi thắng/thua<br />
        <br />
        �� Bạn muốn học cách áp dụng 50/50 chi tiết hơn? �� Inbox ngay để nhận hướng dẫn VIP!</p><br />
    </div>
  )
}

export const Thuthuat5 = () => {
  return (
    <div className={styles.thuthuatContainer}>
      <p className={styles.thuthuatTitle}>
        <b>THỦ THUẬT LV5 </b> PHƯƠNG PHÁP TỰ CHƠI BACARAT
      </p>
      <img style={{ width: '70%' }} src="/assets/thuthuat/tt5.jpg" alt="thuthuat1" />
      <p><b>-BỘ CÔNG THỨC BACCARAT</b></p>
      <p>DÀNH CHO TẤT CẢ CÁC ANH EM KHÔNG CÓ THỜI GIAN THEO NHÓM HOẶC MẤT PHƯƠNG HƯỚNG CHƠI</p>
      <p><b>-CÁCH 1 : </b></p>
      <p>HỆ SỐ CÔNG THỨC CẤP SỐ NHÂN<br />
        ĐÁNH CẦU ĐÁNH CẦU BỆT   VỀ CÁI ĐÁNH CÁI VỀ  CON SẼ ĐÁNH CON<br />
        X1 10K X220K X3 60K X4 240K X5  1200K<br />
        ĂN  THÌ ĐÁNH X1 THUA MÌNH ĐÁNH LÊN X1 10K X220K X3 60K X4 240K X5  1200K</p>
      <p><b>-CÁCH 2 : </b></p>
      <p>CHỌN BÀN CẦU 2.2<br />
        CÁCH ĐÁNH  KHI CẦU ĐANG 123 THÌ MÌNH BẮT ĐẦU VÀO TIỀN BẺ CẦU VÀO TIỀN <br />
        VI DỤ NHƯ CẦU ĐANG ĐI 1 CON 2 CÁI 1 CON THÌ SẼ BẮT ĐẦU VÀO TIỀN TAY CON <br />
        X1 200K X2400K X3 1200K THẮNG THUA QUAY VỀ X1 200K </p>
      <p><b>-CÁCH 3 : </b></p>
      <p>CẦU 1-1 2<br />
        CHỌN BÀN CẦU BỆT 6-8 TAY 2<br />
        SẼ XUẤT HIỆN CẦU 1-1  2<br />
        THẾ CẦU NÀY MỌI NGƯỜI ĐI ĐỀU TAY NẾU CẦU CHẠY 1-1 5 TAY SẼ BẮT ĐẦU BẺ GẤP THÉP VỐN </p>
      <p><b>-CÁCH 4 : </b></p>
      <p>CẦU 1-1 2<br />
        CẦU BỆT  <br />
        HAY BỆT CẦU Ở NHỮNG BÀN CẦU 1-1   <br />
        CÁCH NHẬN BIẾT CẦU 1-1 SẼ ĐI TẦM 5 TAY TRỞ LÊN <br />
        KHI XUẤT HIỆN CẦU THẾ MÌNH SẼ TIẾN HÀNH BẺ XUỐNG CẦU BỆT ĐÁNH ĐỀU TAY BỆT ĐẾN TẦM 8 TAY THÌ MÌNH SẼ TIẾN HÀNH BẺ GẤP THÉP<br />
        CHÚC TẤT CẢ ANH EM THẮNG LỚN VỚI CÔNG THỨC NÀY</p>
    </div>
  )
}


export const Thuthuat6 = () => {
  return (
    <div className={styles.thuthuatContainer}>
      <p className={styles.thuthuatTitle}>
        <b>THỦ THUẬT LV6 </b> PHƯƠNG PHÁP TỰ CHƠI BACARAT
      </p>
      <img style={{ width: '70%' }} src="/assets/thuthuat/tt6.jpg" alt="thuthuat1" />
      <p><b>-CÔNG THỨC 1</b></p>
      <p>KHI GẶP 2 VÁN CON RA 9 NÚT LIÊN TỤC, HOẶC CÁI RA 9 NÚT LIÊN TỤC 2 VÁN THÌ BÁM BỆT. KHẢ NĂNG RA BỆT TRÊN 80%</p>
      <p><b>-CÔNG THỨC 2</b></p>
      <p>KHI GẶP DẠNG CẦU 4-2-1 THÌ ANH EM BÁM CẦU 1-1 TẦM 6-7 TAY, TỶ LỆ RA CẦU 1:1 NÀY TRÊN 70%</p>
      <p><b>-CÔNG THỨC 3</b></p>
      <p>KHI GẶP CON ĐÔI CÁI ĐÔI 2 VÁN LIÊN TỤC THÌ VÁN THỨ 3 VÀ THỨ 4 ANH EM LÓT HOÀ. TỶ LỆ RA HOÀ TRÊN 80%</p>
      <p><b>-CÔNG THỨC 4</b></p>
      <p>KHI GẶP CẦU 1-1 ĐƯỢC TẦM 5-7 TAY, NẾU XUẤT HIỆN RA KẾT QUẢ 9 NÚT THÌ BẺ CẦU, TỶ LỆ WIN TRÊN 90%</p>
    </div>
  )
}

export const Thuthuat7 = () => {
  return (
    <div className={styles.thuthuatContainer}>
      <p className={styles.thuthuatTitle}>
        <b>THỦ THUẬT LV7 </b> PHƯƠNG PHÁP TỰ CHƠI BACARAT
      </p>
      <img style={{ width: '70%' }} src="/assets/thuthuat/tt7.jpg" alt="thuthuat1" />
      <p><b>BỘ CÔNG THỨC BACCARAT</b></p>
      <p>DÀNH CHO TẤT CẢ CÁC ANH EM KHÔNG CÓ THỜI GIAN THEO NHÓM HOẶC MẤT PHƯƠNG HƯỚNG CHƠI</p>
      <p><b>CÁCH 1</b></p>
      <p>HỆ SỐ CÔNG THỨC CẤP SỐ NHÂN<br />
        ĐÁNH CẦU ĐÁNH CẦU BỆT   VỀ CÁI ĐÁNH CÁI VỀ  CON SẼ ĐÁNH CON<br />
        X1 10K X220K X3 60K X4 240K X5  1200K<br />
        ĂN  THÌ ĐÁNH X1 THUA MÌNH ĐÁNH LÊN X1 10K X220K X3 60K X4 240K X5  1200K</p>
      <p><b>CÁCH 2 : CẦU 123</b></p>
      <p>CHỌN BÀN CẦU 2.2<br />
        CÁCH ĐÁNH  KHI CẦU ĐANG 123 THÌ MÌNH BẮT ĐẦU VÀO TIỀN BẺ CẦU VÀO TIỀN <br />
        VI DỤ NHƯ CẦU ĐANG ĐI 1 CON 2 CÁI 1 CON THÌ SẼ BẮT ĐẦU VÀO TIỀN TAY CON <br />
        X1 200K X2400K X3 1200K THẮNG THUA QUAY VỀ X1 200K</p>
      <p><b>CÁCH 3: CẦU 1-1</b></p>
      <p>CHỌN BÀN CẦU BỆT 6-8 TAY <br />
        SẼ XUẤT HIỆN CẦU 1-1  <br />
        THẾ CẦU NÀY MỌI NGƯỜI ĐI ĐỀU TAY NẾU CẦU CHẠY 1-1 5 TAY SẼ BẮT ĐẦU BẺ GẤP THÉP VỐN</p>
      <p><b>CÁCH 4: CẦU BỆT</b></p>
      <p>HAY BỆT CẦU Ở NHỮNG BÀN CẦU 1-1   <br />
        CÁCH NHẬN BIẾT CẦU 1-1 SẼ ĐI TẦM 5 TAY TRỞ LÊN <br />
        KHI XUẤT HIỆN CẦU THẾ MÌNH SẼ TIẾN HÀNH BẺ XUỐNG CẦU BỆT ĐÁNH ĐỀU TAY BỆT ĐẾN TẦM 8 TAY THÌ MÌNH SẼ TIẾN HÀNH BẺ GẤP THÉP<br />
        CHÚC TẤT CẢ ANH EM THẮNG LỚN VỚI CÔNG THỨC NÀY</p>

    </div>
  )
}
export const Thuthuat8 = () => {
  return (
    <div className={styles.thuthuatContainer}>
      <p className={styles.thuthuatTitle}>
        <b>THỦ THUẬT LV8 </b> PHƯƠNG PHÁP TỰ CHƠI BACARAT
      </p>
      <img style={{ width: '70%' }} src="/assets/thuthuat/tt8.jpg" alt="thuthuat1" />
      <p style={{ textAlign: 'center' }}><b>🔥BỘ CÔNG THỨC BACARAT 🔥</b></p>
      <p style={{ textAlign: 'center' }}><b>ÁP DỤNG TRONG SẢNH SEXY BẮT THẾ CẦU CHUẨN 99%</b></p>
      <p style={{ textAlign: 'center' }}><b>DÀNH CHO ANH EM TỰ CHƠI , DẢNH NÚC NÀO CHƠI NÚC ĐÓ</b></p>
      <p><b>-THẾ CẦU 1</b></p>
      <p>- CẦU NGHIÊNG CÁI <br />
        + THẾ CẦU NÀY ANH EM VÀO BÀN NHÌN BẢNG CẦU PHỤ ĐỂ LẮM HƯỚNG KẾT QUẢ SAU BIỂU ĐỒ BẢNG CẦU PHỤ ĐANG ĐI BỆT TỪ 3 - 4 TAY VỀ CÁI THÌ ANH EM BẮT BỆT CÁI<br />
        - CẦU NGHIÊNG CON <br />
        +THẾ CẦU NÀY ANH EM VÀO BÀN NHÌN BẢNG CẦU PHỤ ĐỂ LẮM HƯỚNG KẾT QUẢ SAU BIỂU ĐỒ BẢNG CẦU PHỤ ĐANG ĐI BỆT TỪ 3 - 4 TAY VỀ CON THÌ ANH EM BẮT BỆT CON<br />
        - CẦU NGHIÊNG CON 1 - 1<br />
        THẾ CẦU NÀY THƯỜNG SẼ ĐI 1 -1 NHƯNG NGHIÊNG VỀ PHÍA CON NHIỀU<br />
        CŨNG TƯƠNG TỰ THẾ CẦU TRÊN NHƯNG NẾU VỀ HOÀ THÌ BẮT BỆT CON</p><br />
      <p><b>-THẾ CẦU 2</b></p>
      <p>CẦU 1 CON 2 CÁI<br />
        + THẾ CẦU BẮT NGƯỢC LẠI THẾ CẦU CỦA <br />
        KẾT QUA TAY TRƯỚC<br />
        - CẦU LỪA 123 <br />
        + KHI GẶP THẾ CẦU NÀY MÀ ĐOẠN CUỐI CỦA THẾ CẦU ĐỔ KẾT QUẢ VỀ CON THÌ BẮT BỆT CON + VỀ CÁI THÌ BẮT BỆT CÁI<br />
        - CẦU 12<br />
        + ĐÁNH CHẠM VẾ KẾT QUẢ CA TRƯỚC LÀ CÁI THÌ TAY SAU ĐÁNH X2 VÀO CON ( VÀ NGƯỢC LẠI)<br />
      </p><br />
      <p><b>THẾ CẦU 3 :</b></p>
      <p>- TAY HOÀ 1 - 2 <br />
        ĐOẠN NÀY KẾT QUẢ CHỈ VỀ 2 LẦN LIÊN TIẾP LẦN THỨ 3 ANH EM SẼ BẮT HOÀ NHÉ<br />
        - CẦU HOÀ LỪA <br />
        + PHÍA TRÊN VẾ CẦU CÓ ĐỂ HOÀ VÀ BỆT TỪ 3 4 TAY , TAY SAU SẼ BẺ VÀ BẮT HOÀ TIẾP<br />
        - CẦU LOẠN <br />
        + THƯỜNG HAY XUẤT HIỆN Ở BÀN BACARAT C09 , THẾ CẦU NÀY ĐÁNH THEO BẢNG CẦU PHỤ VÀ CHỈ ĂN 3 4 TAY RỒI ĐỔI BÀN</p><br />
    </div>
  )
}


export const valueThuThuat = [
  {
    url: "/assets/casino/1.png",
    link: "/thuthuat1",
    description: "THỦ THUẬT 1: MIỄN PHÍ",
    coin: 0,
  },
  {
    url: "/assets/casino/2.png",
    link: "/thuthuat2",
    description: "THỦ THUẬT 2: 100 XU",
    coin: 100,
  },
  {
    url: "/assets/casino/3.png",
    link: "/thuthuat3",
    description: "THỦ THUẬT 3: 200 XU",
    coin: 200,
  },
  {
    url: "/assets/casino/4.png",
    link: "/thuthuat4",
    description: "THỦ THUẬT 4: 300 XU",
    coin: 300,
  },
  {
    url: "/assets/casino/5.png",
    link: "/thuthuat5",
    description: "THỦ THUẬT 5: 400 XU",
    coin: 400,
  },
  {
    url: "/assets/casino/6.png",
    link: "/thuthuat6",
    description: "THỦ THUẬT 6: 500 XU",
    coin: 500,
  },
  {
    url: "/assets/casino/7.png",
    link: "/thuthuat7",
    description: "THỦ THUẬT 7: 600 XU",
    coin: 600,
  },
  {
    url: "/assets/casino/8.png",
    link: "/thuthuat8",
    description: "THỦ THUẬT 8: 700 XU",
    coin: 700,
  }
];